import { Navigate, Outlet } from 'react-router-dom'
import HeadHelmet from 'components/route/HeadHelmet'
import useRouteData from 'hooks/useRouteData'
import { SITE_USER_ROOT } from 'config'
import { useAuth } from 'react-oidc-context'
import useUserRole from 'hooks/useUserRole'
import { ClientRoute } from 'routes/client'
import OverlayLoader from 'components/ui/OverlayLoader'

export default function AdminCourseEditorGuard(): JSX.Element {
  const { titleId = '' } = useRouteData()
  const oicdAuth = useAuth()
  const { isGpsEditor, isAdmin, isAdminCourseEditor, isLoading } = useUserRole()

  if (oicdAuth.isLoading || !oicdAuth.isAuthenticated || isLoading) {
    return <OverlayLoader visible={true} />
  }

  if (oicdAuth.isAuthenticated && isGpsEditor) {
    return <Navigate to={SITE_USER_ROOT} />
  }

  if (isAdmin && oicdAuth.isAuthenticated) {
    return <Outlet />
  }

  if (!isAdminCourseEditor && !isAdmin) {
    return <Navigate to={ClientRoute.LOGIN} />
  }

  return (
    <>
      <HeadHelmet titleId={titleId} />
      <Outlet />
    </>
  )
}
